import { MoonStar, Check } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const OCCASIONS = [
  "Treffi-illat",
  "Vanhempien yhteinen illanvietto",
  "Oma aika",
  "Viikonloppumenot",
  "Iltarutiinit",
  "Myöhäiset illat",
  "Mahdollisuuksien mukaan yöhoito",
];

export const NightCare = () => (
  <section id="ilta-ja-yo" className="px-3 py-6 sm:px-6" data-testid="nightcare-spotlight-section">
    <div className="relative mx-auto max-w-[88rem] overflow-hidden rounded-[2.5rem] bg-petrol-night text-cream sm:rounded-[3rem]">
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(55% 45% at 78% 12%, rgba(201,169,126,0.22), transparent 70%), radial-gradient(40% 40% at 8% 90%, rgba(29,78,83,0.55), transparent 70%)",
        }}
      />
      <MoonStar
        className="pointer-events-none absolute right-10 top-10 hidden h-24 w-24 text-cream/[0.06] animate-floatslow sm:block"
        strokeWidth={0.75}
        aria-hidden="true"
      />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 gap-12 px-6 py-20 sm:px-10 sm:py-24 lg:grid-cols-2 lg:gap-20 lg:px-16 lg:py-28">
        <div>
          <Reveal>
            <Eyebrow index="05" label="Ilta- ja yöhoito" light />
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-7 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-cream sm:text-5xl lg:text-[3.4rem]">
              Treffi-ilta? Oma hetki?{" "}
              <em className="italic text-beige">Minä pidän huolen lapsista.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-cream/75 sm:text-lg">
              Opiskelen psykologiaa päivisin, joten hoidot sopivat erityisesti
              iltoihin ja viikonloppuihin – sovittaessa myös myöhään yöhön asti.
              Minulla on kokemusta monenikäisten lasten nukuttamisesta
              päiväunille sekä yöunille, ja olen hoitanut myös 1,5-vuotiasta
              lasta koko yön yli – ja se sujui hyvin. Pidempikään hoitokerta ei
              siis ole minulle vieras.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
              <button
                data-testid="nightcare-cta-button"
                onClick={() => scrollToId("yhteydenotto")}
                className="rounded-full bg-cream px-8 py-4 text-base font-semibold text-petrol-night transition-all duration-300 hover:-translate-y-0.5 hover:bg-beige"
              >
                Ota yhteyttä
              </button>
              <span className="text-xs font-medium tracking-wide text-cream/50">
                Yöhoito sovitaan aina tapauskohtaisesti ja mahdollisuuksien mukaan
              </span>
            </div>
          </Reveal>
        </div>

        <div className="lg:pt-6">
          <Reveal delay={0.2}>
            <ul className="space-y-4">
              {OCCASIONS.map((o) => (
                <li key={o} className="flex items-center gap-4 border-b border-cream/10 pb-4 text-base font-medium text-cream/90 sm:text-lg">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-beige/15">
                    <Check className="h-3.5 w-3.5 text-beige" strokeWidth={2.5} />
                  </span>
                  {o}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
